export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/new_badge_en-36dfd952eab90f26b154ec4a66f853ee.png";